import { render, staticRenderFns } from "./TagContacts.vue?vue&type=template&id=25391086&"
import script from "./TagContacts.vue?vue&type=script&lang=js&"
export * from "./TagContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports